import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { MyActiveCartService } from './my-active-cart.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: ActiveCartService,
      useClass: MyActiveCartService,
    },
  ],
})
export class ServicesModule {}
